<template>
    <v-card-title component="ShortlistHeader">
        <div class="label">Shortlist</div>
        <div class="buttons">
            <btn
                class="send"
                size="small"
                radius="mediumLeft"
                color="base"
                v-if="canSendProject"
                :icon="'send'"
                :text="'Send'"
                :state="!projectHasCharacter ? 'disabled' : ''"
                @click="setProjectSendDialog(true)"
            />
            <btn
                class="approve"
                size="small"
                radius="mediumLeft"
                color="accent"
                v-if="canApproveProject"
                :icon="'check'"
                :text="'Approve'"
                :state="!projectHasCharacter ? 'disabled' : ''"
                @click="setProjectApproveDialog(true)"
            />
            <btn
                class="order"
                size="small"
                radius="mediumLeft"
                color="primary"
                v-if="canCloseProject"
                :icon="'shopping_cart'"
                :text="'Order'"
                :state="!projectHasCharacter ? 'disabled' : ''"
                @click="$router.push({ name: 'project-order', params: { project_id: project.id } })"
            />
            <btn
                class="prolong"
                size="small"
                radius="none"
                color="secondary"
                v-if="canProlongProject"
                :icon="'restore'"
                :text="'Prolong'"
                @click="setProjectProlongDialog(true)"
            />
            <btn
                class="settings"
                size="iconSmall"
                :radius="projectWasClosed ? '' : 'bigRight'"
                :icon="'settings'"
                :class="{ projectWasClosed }"
                @click="setProjectStatusDialog(true)"
            />
        </div>
    </v-card-title>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ShortlistHeader',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            projectVideoDialog: false,
            projectVideoDialogAfter: false,
            projectVideoDialogCharacter: null,
        };
    },

    async mounted() {},

    computed: {
        ...mapGetters([
            'canSendProject',
            'canApproveProject',
            'canProlongProject',
            'canCloseProject',
            'projectWasClosed',
            'projectHasCharacter',
        ]),
    },

    methods: {
        ...mapActions([]),
        ...mapMutations([
            'setProjectStatusDialog',
            'setProjectApproveDialog',
            'setProjectProlongDialog',
            'setProjectSendDialog',
        ]),
    },

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='ShortlistHeader'] {
    .flex-row;
    .font;
    justify-content: space-between;
    padding: 6px 15px !important;
    color: black;
    height: 45px;
    flex-wrap: nowrap;

    .label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .buttons {
        .flex-row;

        .send {
            padding-left: 7px;

            i {
                font-size: 18px;
            }
        }

        .order {
            padding-left: 8px;
        }

        .settings {
            i {
                margin-right: 3px;
            }

            &.projectWasClosed {
                i {
                    margin: 0;
                }
            }
        }
    }
}
</style>
